import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { generate } from 'shortid';
// components
import FieldGroup from '../FieldGroup/FieldGroup';
import { UserCredential } from '../../models/UserCredential';

const Login = observer(
class Login extends Component {
  constructor(props) {
    super(props);

    this.ids = {
      email: generate(),
      password: generate(),
    };

    this.userCredential = props.userCredential || new UserCredential();
  }

  render() {
    const {
      hideLoginButton = false,
      hideEmailField = false,
    } = this.props;

    return (
      <div className="Login-container">
        <form onSubmit={this.handleOnSubmit}>
          {hideEmailField ? null :
            <FieldGroup
              focus
              id={this.ids.email}
              name="email"
              label="E-mail"
              type="email"
              value={this.userCredential.email}
              placeholder="bob@example.com"
              onChange={this.handleChange} />
          }
          <FieldGroup
            focus={hideEmailField}
            id={this.ids.password}
            name="password"
            label="Password"
            type="password"
            value={this.userCredential.password}
            placeholder="**********"
            onChange={this.handleChange} />
          <Row style={{display: hideLoginButton ? "none" : ""}}>
            <Col xs={3}>
              <Button type="submit" bsStyle="primary">Log in</Button>
            </Col>
            <Col xs={9}>
              {this.renderErrorMessage()}
            </Col>
          </Row>
          <div style={{display: !hideLoginButton ? "none" : ""}}>
            {this.renderErrorMessage()}
          </div>
        </form>
      </div>
    );
  }

  renderErrorMessage = () => {
    return (<div style={{"fontSize": "9pt"}} className="text-danger">{this.props.errorMessage}</div>);
  }

  handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;
    let data = {};
    data[name] = value;
    this.userCredential.set(data);

    const onChange = this.props.onChange;
    if (onChange) {
      onChange(this.userCredential);
    }
    return false;
  }

  handleOnSubmit = (e) => {
    e.preventDefault();

    const { onLogin } = this.props;

    if (onLogin) {
      onLogin(this.userCredential.email, this.userCredential.password);
    }

    return false;
  }
});

export default Login;


// WEBPACK FOOTER //
// ./src/components/Auth/Login.js